import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./module1.css";
import CalendlyButton from './components/CalendlyButton';

const Module1 = () => {
  return (
    <div className="mt-2" style={{ backgroundColor: "white" }}>
      <div className="text-center text-white d-flex flex-column justify-content-center align-items-center pt-5 pb-1">
        {/* Primeiro h5 */}
        <h2
          className="col-10 col-md-7 fw-bold text-black"
          style={{ letterSpacing: "5px", color: "", lineHeight: "42.0px" }}
        >
          ACESSE OPORTUNIDADES EXCLUSIVAS EM EURO COM RETORNOS ANUAIS
          CONSISTENTES DE{" "}
          {/* <p className="m-0"></p>
          <span
            className="fw-bold fs-2"
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "0px 4px",
              borderRadius: "5px",
              
            }}
          >
            8% A 20% AO ANO, EM EUROS.
          </span> */}
          <span
            className="fw-bold fs-1"
            style={{
              color: "black",
              backgroundColor: "#ECA600",
              padding: "0px 4px",
              borderRadius: "5px",
              letterSpacing: "4px",
            }}
          >
            8% A 25%
          </span>
          {/* <p className="m-0"></p>
          <span
            className="fw-bold"
          >
            TODOS OS ANOS
          </span> */}
        </h2>
        {/* Segundo h5 */}
        <h5 className="col-12 col-sm-6"></h5>{" "}
        {/* Margem adicional para espaçamento */}
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          paddingBottom: "30px",
        
        }}
      >
        <div
          style={{
            border: "2px solid gray",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px rgba(255, 255, 255, 1.0)",
            padding: "10px",
            backgroundColor: "#000",
            width: "90%",
            maxWidth: "960px", // AUMENTA AQUI
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%",
              overflow: "hidden",
              borderRadius: "8px",
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                borderRadius: "8px",
              }}
              src="https://www.youtube.com/embed/T2KIuvHV2T4?si=zHGzHxvRhX45fZeC"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      {/* <div className="d-flex justify-content-center align-items-center">
      <button
        className="btn border-0 mb-3 px-5 py-3 mt-3 fw-bold"
        style={{
          backgroundColor: "#ECA600",
          letterSpacing: "1.8px",
          borderRadius: "50px",
          fontSize: "1.1rem",
          color: "black",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#f0b000";
          e.target.style.color = "#fff";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "#ECA600";
          e.target.style.color = "black";
        }}
        onClick={() => window.open("https://google.com", "_blank")}
      >
        AGENDAR REUNIÃO
      </button>
    </div> */}
    <div>

      <CalendlyButton label="AGENDAR REUNIÃO" />
    </div>

    </div>
  );
};

export default Module1;
